export function getErrorMessage(errorCode: string) {
  switch (errorCode) {
    case "404":
      return {
        title: "Something's gone wrong",
        message: "Sorry – this page isn't available.",
      };
    case "500":
      return {
        title: "Something's gone wrong",
        message: "Sorry – we're having technical trouble",
      };
    default:
      return {
        title: "Something's gone wrong",
        message: "Sorry – this page isn't available.",
      };
  }
}
